import { FilterMatchMode } from 'primereact/api';

export const RELATIVE_MATCH_MODE = 'relative';

export type TimeWindow = '1h' | '24h' | '7d' | '30d';

export type MatchMode = FilterMatchMode | typeof RELATIVE_MATCH_MODE;

export const TIME_WINDOW_OPTIONS: { label: string; value: TimeWindow }[] = [
    { label: '1h', value: '1h' },
    { label: '24h', value: '24h' },
    { label: '7d', value: '7d' },
    { label: '30d', value: '30d' },
];

export const DEFAULT_TIME_WINDOW: TimeWindow = '7d';
